export const getComponentPropertyReferences = (layer: {
  componentPropertyReferences?: Record<string, string>;
}) => {
  if (!layer.componentPropertyReferences) {
    return null;
  }

  const references: { key: string; type: string }[] = [];

  for (const [propertyType, propertyKey] of Object.entries(
    layer.componentPropertyReferences,
  )) {
    references.push({
      key: propertyKey.split('#')[0],
      type: propertyType,
    });
  }

  return references;
};
